// extracted by mini-css-extract-plugin
export default {"root":"vBwwLLWrVR1wQY2DfR5D"};